export default "__VITE_ASSET__BmpIUYeD__"